import React from "react";
import { RouteComponentProps, Route } from "react-router";
import { RedirectToCurrentMonth } from "./Redirects";
import { AbsenceMonth } from "../components/month/AbsenceMonth";

export function MonthView({ match }: RouteComponentProps<{ date: string }>) {
    return (
        <div className="view view-month">
            <Route path={`${match.path}/:date`} component={MonthWithMonthView} />
            <Route exact path={match.path} component={RedirectToCurrentMonth} />
        </div>
    );
}


function MonthWithMonthView({ match }: RouteComponentProps<{ date: string }>) {
    const date = new Date(match.params.date);
    return (
        <AbsenceMonth date={date} />
    );
}
